<template>
  <div class="scroll-column-btn-table-wrap">
    <div
      class="scroll-column-btn-table_wrap"
      :class="{center:isCenterColumn,white:isWhite}"
    >
      <DotLoading v-if="isLoading && rowData.length === 0" />
      <perfect-scrollbar
        v-if="rowData.length > 0"
        class="ps scroll-column-btn-table"
        :class="{center:isCenterColumn}"
      >
        <div class="scroll-column-btn-table_header">
          <div
            v-for="(columnHeaderItem,columnHeaderIndex) in columnHeader"
            :key="columnHeaderItem.id"
            class="header-item"
            :class="[{tabletHide:columnHeaderItem.tabletHide,mobileHide:columnHeaderItem.mobileHide,icon:columnHeaderItem.type==='icon','clickable':hasClickableHeader && columnHeaderItem.clickable,'no-wrap': columnHeaderItem.noWrap},columnHeaderItem.align]"
            :style="{flex: `${columnHeaderItem.width==='auto'? 1 : 0} 0 ${columnHeaderItem.width}`,minWidth :`${columnHeaderItem.minWidth}px`,padding:columnHeaderItem.padding}"
            @click="$_headerClick(columnHeaderIndex,columnHeaderItem.id)"
          >
            {{ $t(columnHeaderItem.textLabel) }} <span
              v-if="hasClickableHeader && columnHeaderItem.clickable"
              class="header-item_click-btn"
            >
              <i
                class="icon-sort-arrow-up header-item_click-btn-icon"
                :class="{active : ingClickHeaderIndex === columnHeaderIndex && ingClickHeaderSort === 'desc'}"
              /><i
                class="icon-sort-arrow-down header-item_click-btn-icon"
                :class="{active : ingClickHeaderIndex === columnHeaderIndex && ingClickHeaderSort === 'asc'}"
              /></span>
          </div>
        </div>
        <div class="scroll-column-btn-table_content">
          <div
            v-for="(rowItem, rowItemIndex) in rowData"
            :key="rowItemIndex"
            class="scroll-column-btn-table_row"
            :class="{
              'no-border-bottom': rowItemIndex + 1 === rowData.length && isWhite,
              disable: disable,
            }"
            @click="$_onClickItem(rowItem)"
          >
            <div
              v-for="(columnHeaderItem,columnHeaderItem_k) in columnHeader"
              :key="columnHeaderItem_k"
              class="scroll-column-btn-table_column"
              :class="columnHeaderItem.align"
              :style="{flex: `${columnHeaderItem.width==='auto'? 1 : 0} 0 ${columnHeaderItem.width}`,minWidth :`${columnHeaderItem.minWidth}px`}"
            >
              <div
                v-if="columnHeaderItem.type === 'text'"
                class="scroll-column-btn-table_column__text"
                :class="[columnHeaderItem.fontSize, {'no-wrap': columnHeaderItem.noWrap}]"
              >
                {{ rowItem[columnHeaderItem.id] }}
              </div>
              <div
                v-if="columnHeaderItem.type === 'number'"
                class="scroll-column-btn-table_column__number"
                :class="[columnHeaderItem.fontSize,columnHeaderItem.textAlign]"
              >
                {{ rowItem[columnHeaderItem.id] }}<span
                  v-if="columnHeaderItem.unit"
                  class="scroll-column-btn-table_column__number-unit"
                >{{ columnHeaderItem.unit }}</span>
              </div>
              <div
                v-else-if="columnHeaderItem.type === 'expired'"
                class="time"
              >
                <WsTextChip001
                  :leading-icon="columnHeaderItem.timeIcon"
                  :text-label="rowItem[columnHeaderItem.id]"
                  :color="$_getDateOverDue(rowItem[columnHeaderItem.id])"
                  icon-lg
                  font-size-sm
                />
              </div>
              <div
                v-else-if="columnHeaderItem.type === 'date'"
                class="time"
              >
                <WsTextChip001
                  :leading-icon="columnHeaderItem.timeIcon"
                  :text-label="rowItem[columnHeaderItem.id]"
                  color="gray"
                  icon-lg
                  font-size-sm
                />
              </div>
              <div
                v-else-if="columnHeaderItem.type === 'percent'"
                class="time"
              >
                <WsTextChip001
                  :leading-icon="rowItem[columnHeaderItem.id].icon"
                  :text-label="rowItem[columnHeaderItem.id].text"
                  :color="rowItem[columnHeaderItem.id].color"
                  icon-lg
                  font-size-md
                  has-percent
                  is-dark-text
                />
              </div>
              <div
                v-else-if="columnHeaderItem.type === 'button'"
                class="btn"
              >
                <WsButton001
                  flat-button
                  width-stretch
                  @click="$emit('btn-click',rowItem)"
                >
                  {{ columnHeaderItem.buttonText }}
                </WsButton001>
              </div>
              <div
                v-else-if="columnHeaderItem.type === 'rowItembutton'"
                class="btn"
              >
                <WsButton001
                  width-stretch
                  flat-button
                  :white="rowItem.white"
                  :disable="rowItem.disable"
                  @click="$emit('btn-click',rowItem)"
                >
                  {{ $t(rowItem[columnHeaderItem.id]) }}
                </WsButton001>
              </div>
              <div
                v-else-if="columnHeaderItem.type === 'rowItemButtonList' && rowItem[columnHeaderItem.id] && rowItem[columnHeaderItem.id].list && rowItem[columnHeaderItem.id].list.length"
                class="btn"
              >
                <LvFlexBox :noWrap="rowItem[columnHeaderItem.id].noWrap">
                  <WsButton001
                    v-for="(btn, btnIndex) in rowItem[columnHeaderItem.id].list"
                    :key="btnIndex"
                    flatButton
                    widthStretch
                    :disable="btn.disable"
                    :red="btn.color === 'red'"
                    :white="btn.color === 'white'"
                    :class="{'mr-4': btnIndex !== rowItem[columnHeaderItem.id].list.length - 1}"
                    @click="$emit('btn-click',{...rowItem, btn})"
                  >
                    {{ $t(btn.text) }}
                  </WsButton001>
                </LvFlexBox>
              </div>
              <div
                v-else-if="columnHeaderItem.type === 'avatar'"
                class="avatar"
              >
                <LlAvatar
                  :circle-size="22"
                  :text-label="rowItem[columnHeaderItem.id]?rowItem[columnHeaderItem.id].name:''"
                  :image="rowItem[columnHeaderItem.id]?rowItem[columnHeaderItem.id].avatar:''"
                />
              </div>
              <div
                v-else-if="columnHeaderItem.type === 'avatars'"
                class="avatars"
              >
                <LlAvatar
                  v-for="(user, userIndex) in rowItem[columnHeaderItem.id]"
                  :key="userIndex"
                  :circle-size="22"
                  :text-label="user.name"
                  :image="user.avatar"
                  :time="user.time"
                  :timeLabel="user.timeLabel"
                  :subTextLabel="user.subTextLabel"
                  class="mb-2"
                />
              </div>
              <div
                v-else-if="columnHeaderItem.type === 'chip'"
                class="chip"
              >
                <contentChip
                  :text-label="rowItem[columnHeaderItem.id].text"
                  :color="rowItem[columnHeaderItem.id].color"
                />
              </div>
              <div
                v-else-if="columnHeaderItem.type === 'condition'"
                class="condition"
              >
                <WsTextChip001
                  :leading-icon="rowItem[columnHeaderItem.id].icon"
                  :leading-img="rowItem[columnHeaderItem.id].img"
                  :text-label="rowItem[columnHeaderItem.id].text"
                  :color="rowItem[columnHeaderItem.id].color"
                  icon-lg
                  has-bg
                  font-size-sm
                />
              </div>
              <div
                v-else-if="columnHeaderItem.type === 'conditions'"
                class="condition"
              >
                <WsCol>
                  <WsTextChip001
                    v-for="(item, index) in rowItem[columnHeaderItem.id]"
                    :key="index"
                    class="ma-3"
                    :text-label="item.text"
                    :color="item.color"
                    icon-lg
                    has-bg
                    font-size-sm
                  />
                </WsCol>
              </div>
              <div
                v-else-if="columnHeaderItem.type === 'icon'"
                class="icon"
              >
                <router-link
                  :to="
                    rowItem[columnHeaderItem.id].path
                      ? rowItem[columnHeaderItem.id].path
                      : ''
                  "
                  class="scroll-column-btn-table__icon-wrap"
                  :class="rowItem[columnHeaderItem.id].color"
                >
                  <i
                    class="scroll-column-btn-table__icon"
                    :class="rowItem[columnHeaderItem.id].icon"
                    :style="{color: rowItem[columnHeaderItem.id].color}"
                  />
                  <LvText
                    v-if="rowItem[columnHeaderItem.id].text"
                    h6
                  >
                    {{rowItem[columnHeaderItem.id].text}}
                  </LvText>
                </router-link>
              </div>
              <div
                v-else-if="columnHeaderItem.type === 'badge' && rowItem[columnHeaderItem.id]"
                class="badge"
              >
                <ContentChip
                  :yellow="rowItem[columnHeaderItem.id].color==='yellow'"
                  :light-gray="rowItem[columnHeaderItem.id].color==='gray'"
                  :orange="rowItem[columnHeaderItem.id].color==='orange'"
                  :green="rowItem[columnHeaderItem.id].color==='green'"
                  :text-label="$_getLocale(rowItem[columnHeaderItem.id], 'text')"
                  :color="rowItem[columnHeaderItem.id].color"
                />
              </div>
            </div>
          </div>
          <WsButton001
            v-if="showLoadBtn && !isLoading"
            out-line
            class="scroll-column-btn-table_scroll-more-btn"
            @click="$_loadingClick()"
          >
            {{ $t('載入更多') }}
          </WsButton001>
        </div>
      </perfect-scrollbar>
      <div
        v-if="hasLoadMoreBtn && rowData.length > 0 && !isLoading"
        class="scroll-column-btn-table_load-btn-container"
      >
        <div class="scroll-column-btn-table_load-btn">
          <WsButton001
            out-line
            width-stretch
            :leading-icon="bottomLoadBtnIcon"
            @click="$_loadingClick()"
          >
            {{ $t(bottomLoadBtnText) }}
          </WsButton001>
        </div>
      </div>
      <DotLoading v-if="isLoading && rowData.length >0" />
      <LlEmptyPic
        v-if="rowData.length === 0 && !isLoading && !hideEmptyPic"
        :image="require('@/assets/image/img-empty/Blue-file-empty.png')"
        :title="$t('目前尚無資料')"
      />
    </div>
    <div
      v-if="hasBottomBtn"
      class="scroll-column-btn-table_bottom-btn-wrap"
    >
      <div class="scroll-column-btn-table_bottom-btn">
        <WsButton001
          width-stretch
          :leading-icon="bottomBtnIcon"
          :to="bottomBtnTo"
        >
          {{ $t(bottomBtnText) }}
        </WsButton001>
      </div>
    </div>
  </div>
</template>
<script>
import H_common from "@/helpers/common";

export default {
  name: "ScrollColumnBtnTable",
  props: {
    columnHeader: {
      type: Array,
      default() {
        return [];
      },
    },
    rowData: {
      type: Array,
      default() {
        return [];
      },
    },
    to: {
      type: String,
      default: "",
    },
    bottomBtnText: {
      type: String,
      default: "button",
    },
    bottomBtnIcon: {
      type: String,
      default: "",
    },
    bottomLoadBtnText: {
      type: String,
      default: "button",
    },
    bottomLoadBtnIcon: {
      type: String,
      default: "",
    },
    bottomBtnTo: {
      type: String,
      default: "",
    },
    isCenterColumn: {
      type: Boolean,
      default: false,
    },
    hasBottomBtn: {
      type: Boolean,
      default: false,
    },
    hasLoadMoreBtn: {
      type: Boolean,
      default: false,
    },
    isWhite: {
      type: Boolean,
      default: false,
    },
    hasClickableHeader: {
      type: Boolean,
      default: false,
    },
    ingClickHeaderIndex: {
      type: Number,
      default: 0,
    },
    ingClickHeaderSort: {
      type: String,
      default: "",
    },
    showLoadBtn: {
      type: Boolean,
      default: false,
    },
    disable: {
      type: Boolean,
      default: false,
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
    hideEmptyPic: {
      type: Boolean,
      default: false,
    }
  },
  computed: {
    _currentUser() {
      return this.$store.state.stone_auth.currentUser;
    },
  },
  methods: {
    $_avatars(rowItem, columnHeaderItem, type) {
      let _avatar = { name: "", image: "" };
      if (
        columnHeaderItem &&
        columnHeaderItem.id &&
        columnHeaderItem.type === "avatars" &&
        rowItem &&
        rowItem[columnHeaderItem.id] &&
        rowItem[columnHeaderItem.id].length > 0
      ) {
        let _avatars = rowItem[columnHeaderItem.id];
        if (_avatars.find((avatar) => avatar.id === this._currentUser.id)) {
          _avatar.name = this._currentUser.name;
          _avatar.image = this._currentUser.avatar;
        } else _avatar.name = rowItem[columnHeaderItem.id][0].name;
        _avatar.image = rowItem[columnHeaderItem.id][0].avatar;
      }
      if (type === "name") {
        return _avatar.name;
      } else if (type === "image") {
        return _avatar.image;
      } else {
        return "";
      }
    },
    $_avatarsLength(rowItem, columnHeaderItem) {
      if (
        columnHeaderItem &&
        columnHeaderItem.id &&
        rowItem[columnHeaderItem.id].length > 1
      ) {
        return true;
      } else {
        return false;
      }
    },
    $_avatarsTooltips(rowItem, columnHeaderItem) {
      if (
        columnHeaderItem &&
        columnHeaderItem.id &&
        rowItem[columnHeaderItem.id].length > 1
      ) {
        const _avatarsNames = [];
        rowItem[columnHeaderItem.id].forEach((item) => {
          _avatarsNames.push(item.name);
        });
        return _avatarsNames.join();
      } else {
        return "";
      }
    },
    $_getDateOverDue(date) {
      if (!date) return "red";
      let today = new Date();
      let todayDate = this.$moment(today).format("YYYY-MM-DD");
      let targetDate = this.$moment(date).format("YYYY-MM-DD");
      if (this.$moment(todayDate).diff(this.$moment(targetDate), "days") > 0) {
        return "red";
      } else {
        return "gray";
      }
    },
    $_headerClick(headerIndex) {
      let sortWay = "";
      let index = -1;
      if (this.ingClickHeaderIndex !== headerIndex) {
        sortWay = "desc";
        index = headerIndex;
      } else if (this.ingClickHeaderIndex > -1) {
        if (!this.ingClickHeaderSort) {
          sortWay = "desc";
          index = headerIndex;
        } else if (this.ingClickHeaderSort === "desc") {
          sortWay = "asc";
          index = headerIndex;
        } else {
          sortWay = "";
          index = -1;
        }
      } else {
        sortWay = "desc";
        index = headerIndex;
      }
      this.$emit("header-click", {
        sortWay: sortWay,
        index: index,
      });
    },
    $_loadingClick() {
      this.$emit("load-click");
    },
    $_onClickItem(rowItem) {
      if (this.disable) return;
      this.$emit('click', rowItem);
    },
    $_getLocale(object, textKey) {
      return H_common.getLocale(object, textKey);
    },
  },
};
</script>
<style lang="scss">
@import "@/assets/scss/component/scroll-column-btn-table";
</style>